import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Textarea } from "./ui/textarea";

export const ExpenseFormDialog = ({
  expense,
  isEditing,
  onChange,
  onOpenChange,
  onSubmit,
  open,
  users,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="expense-dialog">
        <DialogHeader>
          <DialogTitle>{isEditing ? "Edit Expense" : "Add Expense"}</DialogTitle>
          <DialogDescription>
            Record a report expense for one selected user with its date, category, and amount.
          </DialogDescription>
        </DialogHeader>
        <form className="dialog-form" onSubmit={onSubmit}>
          <Label htmlFor="expense-user">User</Label>
          <select
            id="expense-user"
            data-testid="expense-user-select"
            value={expense.agent_id}
            onChange={(event) => onChange("agent_id", event.target.value)}
            required
          >
            <option value="">Select user</option>
            {users.map((user) => (
              <option key={user.id} value={user.id}>
                {user.name}{user.is_self ? " · Me" : ""}
              </option>
            ))}
          </select>
          <Label htmlFor="expense-description">Description</Label>
          <Input
            id="expense-description"
            data-testid="expense-description-input"
            value={expense.description}
            onChange={(event) => onChange("description", event.target.value)}
            required
          />
          <Label htmlFor="expense-amount">Amount</Label>
          <Input
            id="expense-amount"
            data-testid="expense-amount-input"
            type="number"
            min="1"
            step="0.01"
            value={expense.amount}
            onChange={(event) => onChange("amount", event.target.value)}
            required
          />
          <Label htmlFor="expense-category">Category</Label>
          <select
            id="expense-category"
            data-testid="expense-category-select"
            value={expense.category}
            onChange={(event) => onChange("category", event.target.value)}
          >
            <option value="office">Office</option>
            <option value="transport">Transport</option>
            <option value="salary">Salary</option>
            <option value="commission">Commission</option>
            <option value="other">Other</option>
          </select>
          <Label htmlFor="expense-date">Date</Label>
          <Input
            id="expense-date"
            data-testid="expense-date-input"
            type="date"
            value={expense.expense_date}
            onChange={(event) => onChange("expense_date", event.target.value)}
            required
          />
          <Label htmlFor="expense-notes">Remark</Label>
          <Textarea
            id="expense-notes"
            data-testid="expense-notes-input"
            value={expense.notes}
            onChange={(event) => onChange("notes", event.target.value)}
          />
          <Button type="submit" data-testid="save-expense-button">
            {isEditing ? "Save Expense Changes" : "Save Expense"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};